import OperationDetail from '../components/OperationDetail.vue';
import Vue from 'vue';
const operationDetailHandler = (operation,callback) => {
  const vm = new Vue({
    ...OperationDetail,
    propsData: { operation, callback },
  });
  vm.$mount();
  vm.$bvModal.show('operation-detail-modal');
};
export default operationDetailHandler;
